import { render, staticRenderFns } from "./Drops.vue?vue&type=template&id=567bd563&scoped=true&"
import script from "./Drops.vue?vue&type=script&lang=js&"
export * from "./Drops.vue?vue&type=script&lang=js&"
import style0 from "./Drops.vue?vue&type=style&index=0&id=567bd563&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567bd563",
  null
  
)

export default component.exports